/*  Debouncer
 *
 *    This module returns a method that takes the input text value and calls the provided callback function with
 *    the latest value at the given delay interval.  When a burst of requests is recieved
 *    the method is designed to callback with the initial request immediately and then meter out
 *    the remaining requests.
 *
 *    This is useful for components like typeahead to reduce API requests that are made based on
 *    an input value that changes rapidly (e.g. keyboard text input).
 */

/**
 *
 * @param {number} delay - Delay in milliseconds between debounced values.
 */
export default function Debouncer(delay) {
  let debounceInterval = null
  let latestValue = ''

  return {
    debounce: function debounceValueAtInterval(value, setDebouncedValue) {
      if (latestValue !== value) {
        latestValue = value
        if (!debounceInterval) {
          setDebouncedValue(latestValue)

          debounceInterval = setInterval(() => {
            if (latestValue !== value) {
              setDebouncedValue(latestValue)
              value = latestValue
            } else {
              clearInterval(debounceInterval)
              debounceInterval = null
            }
          }, delay)
        }
      }
    },
    reset() {
      if (debounceInterval) {
        clearInterval(debounceInterval)
        debounceInterval = null
      }
      latestValue = ''
    },
  }
}
